declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';

@Component({
    selector: 'follicularedit',
    templateUrl: './follicularedit.modal.html',
    styleUrls: ['./follicularedit.modal.scss']
})

export class NgbFollicularEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    @Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    @Input() Eggsourcetype: string;
    public EggSourceType: string;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    private isvisibleendo: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveFollicularScanDetailRequest: SaveFollicularScanDetailRequest;
    CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
    CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
    CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    CurrentSaveFollicularPickupsDetailV2Request: SaveFollicularPickupsDetailV2Request;
    CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveFollicularScanDetailRequest = new SaveFollicularScanDetailRequest();

      this.CurrentSaveFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularScanOvaryDetailRequest = new SaveFollicularScanOvaryDetailRequest();
      this.CurrentSaveFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
      this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularPickupsDetailV2Request = new SaveFollicularPickupsDetailV2Request();

      this.CurrentSaveFollicularPickupsDetailV2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
      this.LoadCycles();
      this.LoadScansData();
      this.LoadOvaryData();
      
      this.LoadTestData();
      this.LoadMedicineData();

    }

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    FollicularData: TreatmentCycleStatusController[];
    FollicularData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.FollicularData = this.ApiResData.Result;
                    var Follicularlist = this.FollicularData.filter(
                        function (b) {
                            return b.PhaseActivity == "Follicular Scans";
                        });
                    this.FollicularData = Follicularlist;
                    this.FollicularData2 = this.FollicularData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //  this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentFollicularScanDetailController: FollicularScanDetailController[];
    FollicularScanEndInfo: FollicularScanDetailController;
    CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanDetailController();
    }

    GetFollicularScanDetailController() {
        //this.StartRefreshing();

        this.CurrentFollicularScanDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentFollicularScanDetailRequest.PatientCode = this.PatientCode;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanDetailController = this.ApiResData.Result;
                    this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];

                    if (this.FollicularScanEndInfo.ScanDate != null) {
                        var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ScanDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularScanEndInfo.NextDocDate != null) {
                        var SValidFrom = new Date(this.FollicularScanEndInfo.NextDocDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.NextScanDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
    FollicularScanOvaryInfo: FollicularScanOvaryDetailController;
    CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

    LoadOvaryData() {
        //alert("ScansData")
        this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanOvaryDetailController();
    }

    GetFollicularScanOvaryDetailController() {
        //this.StartRefreshing();

        this.CurrentFollicularScanOvaryDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode
        this.CurrentFollicularScanOvaryDetailRequest.PatientCode = this.PatientCode;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
                    this.FollicularScanOvaryInfo = this.CurrentFollicularScanOvaryDetailController[0];
                    //this.SelectedActorCode = this.CurrentFollicularScanOvaryDetailController[0].ActorID;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //this.LoadPatients();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.LoadDSAData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
      // alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        // this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularScanEndInfo.ScanDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }

    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("ScansData")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.ActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
    CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

    LoadMedicineData() {
        //alert("ScansData")
        this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMedicineByCodeController();
    }

    GetIvfCycleMedicineByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.ActivityCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    // this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.LoadPlanDetails();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    onSubmit_NextScanDate() {
        this.isvisibleendo = false;
        this.spinner.show();
        //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness = this.FollicularScanEndInfo.EndometriumThickness;
        //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
        this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentSaveFollicularScanDetailRequest.NextScanDate = new Date(this.parserFormatter.format(this.NextScanDate));
        //this.CurrentSaveFollicularScanDetailRequest.NextScanDate=
        //this.CurrentSaveFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
        //this.CurrentSaveFollicularScanDetailRequest.Doc = this.SelectedpatientDetails.DOC;
        //this.CurrentSaveFollicularScanDetailRequest.ActorType = AppData.Instance().UserLoginDetails.ActorType.toString();
        //this.CurrentSaveFollicularScanDetailRequest.ActorID = this.SelectedpatientDetails.ActorID;
        //this.CurrentSaveFollicularScanDetailRequest.CycleActivity = this.SelectedpatientDetails.CycleActivity;
        //this.CurrentSaveFollicularScanDetailRequest.EndometriumDetails = "";
        //this.CurrentSaveFollicularScanDetailRequest.EndometriumThicknessUnits = this.FollicularScanEndInfo.EndometriumThicknessUnits;
        // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = this.FollicularScanEndInfo.Sign1Actor;
        //this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = this.FollicularScanEndInfo.Sign2Actor;

        this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 27;
        this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.isvisibleendo = true;
                        this.spinner.hide();
                        //this.activeModal.close();
                        this.clearData();
                        this.LoadScansData();

                        this.NewActivity();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();
                        this.spinner.hide();
                    }

                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();

                        this.spinner.hide();

                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeAsstSurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularScanDetailRequest.Sign2 = event;
            //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
            //this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onSubmit() {
        this.isvisibleendo = false;
        this.spinner.show();
        this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness = this.FollicularScanEndInfo.EndometriumThickness;
        this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
        this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
        this.CurrentSaveFollicularScanDetailRequest.Doc = this.DOC;
        this.CurrentSaveFollicularScanDetailRequest.ActorType = AppData.Instance().UserLoginDetails.ActorType.toString();
        this.CurrentSaveFollicularScanDetailRequest.ActorID = this.ActorCode;
        this.CurrentSaveFollicularScanDetailRequest.CycleActivity = this.ActivityCode;
        this.CurrentSaveFollicularScanDetailRequest.EndometriumDetails = "";
        this.CurrentSaveFollicularScanDetailRequest.EndometriumThicknessUnits = this.FollicularScanEndInfo.EndometriumThicknessUnits;
        this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = this.FollicularScanEndInfo.Sign1Actor;
        this.CurrentSaveFollicularScanDetailRequest.Sign2Actor = this.FollicularScanEndInfo.Sign2Actor;

        this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 20;
        this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.isvisibleendo = true;
                        //this.activeModal.close();
                        this.clearData();
                        this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onSubmitOvary() {
        this.isvisible = false;
        this.spinner.show();
        this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = 0;
        this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = this.PatientCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = this.FollicularGrowthCode;
        // this.CurrentSaveFollicularScanDetailRequest.ScanDate = new Date(this.parserFormatter.format(this.ScanDate));
        this.CurrentSaveFollicularScanOvaryDetailRequest.ConditionalOperator = 10;
        this.actorservice.SaveFollicularScanOvaryDetail(this.CurrentSaveFollicularScanOvaryDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.isvisible = true;
                        this.LoadOvaryData();
                        //this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {
                        this.spinner.hide();
                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }

    onSubmitAdditional() {
        this.isvisibleendo = false;
        this.spinner.show();
        this.CurrentSaveFollicularScanDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.FollicularGrowthCode = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentSaveFollicularScanDetailRequest.BloodFlowZone = this.FollicularScanEndInfo.BloodFlowZone;
        //this.CurrentSaveFollicularScanDetailRequest.UALeft = this.FollicularScanEndInfo.U;

        //this.CurrentSaveFollicularScanDetailRequest.UARight = this.FollicularScanEndInfo.UterineArteryRight;
        this.CurrentSaveFollicularScanDetailRequest.PILeft = this.FollicularScanEndInfo.PILeft;
        this.CurrentSaveFollicularScanDetailRequest.PIRight = this.FollicularScanEndInfo.PIRight;

        this.CurrentSaveFollicularScanDetailRequest.RILeft = this.FollicularScanEndInfo.RILeft;
        this.CurrentSaveFollicularScanDetailRequest.RIRight = this.FollicularScanEndInfo.RIRight;


        this.CurrentSaveFollicularScanDetailRequest.Evion = this.FollicularScanEndInfo.Evion;
        this.CurrentSaveFollicularScanDetailRequest.GCSF = this.FollicularScanEndInfo.GCSF;
        this.CurrentSaveFollicularScanDetailRequest.BAPC = this.FollicularScanEndInfo.BAPC;



        this.CurrentSaveFollicularScanDetailRequest.ConditionalOperator = 15;
        this.actorservice.SaveFollicularScanDetail(this.CurrentSaveFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.isvisibleendo = true;
                        //this.activeModal.close();
                        this.clearData();
                        this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController[];
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadPlanDetails() {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = this.CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }
    GetIvfTreatmentPlanController() {
        //this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];

                    this.spinner.hide();
                    //this.stopRefreshing();
                    // this.LoadActivities();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    NewActivity() {
        //alert("On Submit");

        this.CurrentSaveTestMedCycleActivitiesRequest.PlanCode = this.PlanDetails.FollowupPlanCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityDate = new Date(this.parserFormatter.format(this.NextScanDate));
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityTime = "10:00";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupMode = "Email";
        this.CurrentSaveTestMedCycleActivitiesRequest.FollowupStatus = "Active";
        this.CurrentSaveTestMedCycleActivitiesRequest.AssignedToName = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.Assignedto = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
        this.CurrentSaveTestMedCycleActivitiesRequest.ActivityStatus = "";
        this.CurrentSaveTestMedCycleActivitiesRequest.CounsellingActivityCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleActivityCode = 0;

        if (this.SelectedpatientDetails.EggSourceType == "Self") {
            this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.SelectedpatientDetails.OwnerActorCode;
            this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType = "SELF";
        }

        else if (this.SelectedpatientDetails.EggSourceType = "Donor") {
            this.CurrentSaveTestMedCycleActivitiesRequest.ActorCode = this.SelectedpatientDetails.EggActorCode;
            this.CurrentSaveTestMedCycleActivitiesRequest.ActivityType = "DONOR";
        }
        this.CurrentSaveTestMedCycleActivitiesRequest.ClinicalOrderEntryCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.LoginUserActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveTestMedCycleActivitiesRequest.BasePrice = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.CycleTestCode = 0;
        this.CurrentSaveTestMedCycleActivitiesRequest.DOC = this.GetDoc(new Date(this.parserFormatter.format(this.NextScanDate)));
        this.CurrentSaveTestMedCycleActivitiesRequest.TestCode = 124;
        this.CurrentSaveTestMedCycleActivitiesRequest.ServiceName = "FOLLICULAR GROWTH SCAN";
        this.CurrentSaveTestMedCycleActivitiesRequest.Remarks = "";
        //alert(this.GetDoc(new Date(this.parserFormatter.format(this.NextScanDate))));
        //this.cure
        this.CurrentSaveTestMedCycleActivitiesRequest.ConditionalOperator = 10;

        this.actorservice.SaveTestMedCycleActivities(this.CurrentSaveTestMedCycleActivitiesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                    //this.activeModal.close();
                    this.spinner.hide();
                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



                    }
                    else {
                        this.stopRefreshing();
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );

    }
    NewDate: Date = new Date();
    GetDoc(nextscandate: Date): number {
        var Datenew = new Date(nextscandate)
        var LMPDay = Datenew.getDate();
        //alert(this.LMPDay);
        var CurrentDay = this.NewDate.getDate();
        //alert(this.CurrentDay);
        var Doc = (CurrentDay - LMPDay) + 1;
        return Doc;
    }

    clearData() {
        this.CurrentSaveFollicularScanOvaryDetailRequest.Count = null;
        this.CurrentSaveFollicularScanOvaryDetailRequest.Size = null;
        this.CurrentSaveFollicularScanOvaryDetailRequest.Remarks = null;

    }
    edit(l: FollicularScanOvaryDetailController) {

        this.CurrentSaveFollicularScanOvaryDetailRequest.OvarPos = l.OvarPos;
        this.CurrentSaveFollicularScanOvaryDetailRequest.Count = l.Count;
        this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = l.FollicularGrowth;
        this.CurrentSaveFollicularScanOvaryDetailRequest.Size = l.Size;
        this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = l.PatientCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = l.TreatmentCycle;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = l.FollicularGrowth;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = l.FollicularGrowthDetailCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.Remarks = l.Comments;


        const modalRef = this.modalService.open(NgbEditOvaryModal,
            {
                centered: true

            })
        modalRef.componentInstance.CurrentSaveFollicularScanOvaryDetailRequest = this.CurrentSaveFollicularScanOvaryDetailRequest;
        modalRef.result.then(x => { this.GetFollicularScanOvaryDetailController() })
    }
    del_(FollicularGrowthDetailCode: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentities(FollicularGrowthDetailCode);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentities(FollicularGrowthDetailCode: any) {


        console.log('..................');
        //this.StartRefreshing();
        this.CurrentSaveFollicularScanOvaryDetailRequest.ConditionalOperator = 30;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowthDetailCode = FollicularGrowthDetailCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.FollicularGrowth = this.FollicularGrowthCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.PatientCode = this.PatientCode;
        this.CurrentSaveFollicularScanOvaryDetailRequest.ScanCode = this.FollicularGrowthCode;
        this.actorservice.SaveFollicularScanOvaryDetail(this.CurrentSaveFollicularScanOvaryDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        this.LoadOvaryData();

                        // this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

    AddTests() {
        const modalRef = this.modalService.open(NgbAddScanTestModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

          })
        modalRef.componentInstance.Typeofscreen = 'Scan';
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.ActivityCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;


        //if (this.SelectedpatientDetails.EggSourceType == 'Donor') {
        //    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.EggActorCode;
        //}
        //else if (this.SelectedpatientDetails.EggSourceType == 'self'){
        //    modalRef.componentInstance.ActorCode1 = this.SelectedpatientDetails.ActorID;

        //}
        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;
        modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleTestByCodeController[0].ClinicalOrderItem;
        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    }
    AddMedicine() {
        const modalRef = this.modalService.open(NgbAddScanMedicineModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.Typeofscreen = 'Scan';
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.ActivityCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.ScanDate = this.FollicularScanEndInfo.ScanDate;
        //if (this.SelectedpatientDetails.EggSourceType == 'Donor') {
        //    modalRef.componentInstance.ActorCode1 = this.ActorCodeDetails.EggActorCode;
        //}
        //else if (this.SelectedpatientDetails.EggSourceType == 'self') {
        //    modalRef.componentInstance.ActorCode1 = this.SelectedpatientDetails.ActorID;

        //}

        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        // alert(modalRef.componentInstance.ActorCode1);
        modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
        modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditMedicine(l: IvfCycleMedicineByCodeController) {
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
        this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
        this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
        this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
        this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
        this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;

        //this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode
        //this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;

        //this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
        //this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
        //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;
        //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";



        const modalRef = this.modalService.open(NgbEditScanMedicineModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
        modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditTest(l: IvfCycleTestByCodeController) {

        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.ActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
        this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
        this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
        this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
        this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
        this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

        const modalRef = this.modalService.open(NgbEditScanTestModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    delTEST(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesTest(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesTest(l: any) {
        var item = l as IvfCycleTestByCodeController;



        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.ActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.ActorCode;

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        //this.LoadOvaryData();
                        this.LoadTestData();
                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    AddEventDetails() {
        const modalRef = this.modalService.open(NgbEventAddModal,
            {
                centered: true,
                keyboard: false,
                backdrop: 'static'

            })
        modalRef.componentInstance.ActorCode = this.ActorCode;
        //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
    }
    delMedicine(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesMedicine(l: any) {
        var item2 = l as IvfCycleMedicineByCodeController;

        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;

        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode;

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    pickup() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false,
        }).then(() => {

            this.IsReadyForPickup();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    IsReadyForPickup() {


        console.log('..................');
        //  this.StartRefreshing();
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 1;

        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.DOC = this.DOC;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowthCode = this.FollicularGrowthCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.LoadScansData();
                        this.LoadOvaryData();
                        this.LoadTestData();
                        this.LoadMedicineData();
                        this.spinner.hide();
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        // this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }


    //printfollicular() {
    //  this.router.navigate(['print/folliculargrowth', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
    //}
    printfollicular2() {
        this.printService.printDocument("follicularscans",
            {
                ScanCodeData: this.FollicularGrowthCode, CycleCode: this.CycleCode, PatientCode: this.PatientCode, CycleType: this.SelectedpatientDetails.CycleType, Doc: this.DOC, DocDate: this.SelectedpatientDetails.ProtocolStartDate, CycleActivity: this.ActivityCode, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo,
                DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
                GradingModelData: this.GradingModel, TcModelData: this.SelectedpatientDetails.TCModelName
            },

        );

        //    this.router.navigate(['print/follicularscans', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
    }

    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }





}
